import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import {
  TotalPassDetalleDispatcher,
  totalPassDetalleDispatcher
} from "./TotalPassDetalle.dispatcher";
import {
  TotalPassDetalleStore,
  totalPassDetalleStore
} from "./TotalPassDetalle.store";
import TotalPassDetalleComponent from "../../components/totalPassDetalle";

interface Props extends TotalPassDetalleStore, TotalPassDetalleDispatcher {}
interface State {}

@ReduxConnect(totalPassDetalleStore, totalPassDetalleDispatcher)
export default class TotalPassDetalleContainer extends React.Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="TotalPassDetalle especiales" />
          <TotalPassDetalleComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
